import React from 'react';
import styled from 'styled-components';

function getColor(minutes) {
  const abs = Math.abs(minutes || 0);
  if (abs < 1)  return { fg: '#6d6d6d', bg: '#ffffff' };
  if (abs < 5)  return { fg: '#2ECC71', bg: '#E8F5E9' };
  if (abs < 15) return { fg: '#F39C12', bg: '#FFF8E1' };
  return { fg: '#E74C3C', bg: '#FFEBEE' };
}

const Pill = styled.span`
  display: inline-block;
  padding: 2px 8px;
  font-size: 12px;
  font-family: ${p => p.theme.typography.monoFamily};
  font-weight: ${p => p.theme.typography.weights.medium};
  border-radius: 10px;
  color: ${p => p.fg};
  background: ${p => p.bg};
  border: 1px solid ${p => p.fg}33;
  white-space: nowrap;
  margin-right: 4px;
`;

const DeltaBadge = ({ delta }) => {
  if (!delta || typeof delta.minutes !== 'number') return null;
  const { fg, bg } = getColor(delta.minutes);
  return <Pill fg={fg} bg={bg}>{delta.display || `${delta.minutes}m`}</Pill>;
};

export default DeltaBadge;
